var _circle, _path, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccionaLeafMarker({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_84_2)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.633 28.5672C24.847 27.7145 25.0504 26.8668 25.2356 26.0243C25.5748 24.4853 25.8487 22.959 25.9765 21.4353C26.013 21.0102 26.0287 20.6005 26.047 20.1933C26.0783 19.5506 26.0861 18.9283 26.0704 18.3342C26.0496 17.2817 25.9765 16.306 25.8643 15.4277C25.713 14.2753 25.4678 13.3022 25.2878 12.4673C25.4704 12.6108 25.6609 12.7516 25.8461 12.8848C26.0548 13.5019 26.3104 14.3649 26.5478 15.443C26.7043 16.1677 26.8556 17.0051 26.9756 17.9245C27.8443 17.5608 28.6896 17.1229 29.4617 16.6082L29.4435 17.799C28.7104 18.3982 27.933 18.9437 27.1322 19.4353C27.2443 20.79 27.2783 22.3009 27.1817 23.9526C27.1478 24.4699 27.1035 24.9821 27.0539 25.4968C28.7261 25.0384 30.487 24.3419 31.987 23.338L31.9635 24.5339C30.3722 25.8476 28.5356 26.9027 26.793 27.6325C26.54 29.3534 26.2296 31.0615 25.94 32.7874C28.2252 32.4853 31.2983 31.6632 33.6904 30.0576L33.6696 31.2535C31.1391 33.338 28.0035 34.7772 25.5617 35.2663C25.0583 38.8617 24.8522 42.6517 25.7365 46.9949L22.893 45.3406C21.787 39.1818 23.3391 33.758 24.633 28.5672Z",
    fill: "#E20714"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_84_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 7,
    width: 27,
    height: 34
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9946 7.01819H14.0025V40.2858H40.9946V7.01819Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_84_2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.7685 40.2856C31.4312 40.219 38.3651 36.6621 40.7338 31.6838C40.7338 31.6838 40.9216 31.2869 40.9946 31.1332C40.8929 30.9898 40.6425 30.639 40.6425 30.639C39.8051 29.4713 38.8085 27.5174 38.8085 24.8285C38.8085 24.0142 38.952 23.0308 39.2468 21.8451C39.2468 21.8451 39.3694 21.3432 39.4242 21.1358C39.2442 21.0206 38.8085 20.7312 38.8085 20.7312C37.2564 19.7043 34.5825 17.2408 34.1912 12.2344C34.1912 12.2344 34.1442 11.6454 34.1285 11.4047C33.8833 11.374 33.299 11.2869 33.299 11.2869C31.7051 11.0436 28.632 10.2651 25.9633 7.70943C25.9633 7.70943 25.4651 7.22799 25.2433 7.01801C25.0268 7.22799 24.5259 7.70943 24.5259 7.70943C21.8572 10.2651 18.7868 11.0436 17.1929 11.2869C17.1929 11.2869 16.6007 11.374 16.3633 11.4047C16.3633 11.6454 16.3581 12.237 16.3581 12.237C16.3268 15.9911 14.6546 17.5225 14.0025 17.9758C14.2164 18.1627 14.4668 18.3727 14.5894 18.4751C16.2016 17.8426 18.119 16.4239 18.372 13.2049C20.0859 12.8413 22.6738 11.9476 25.0998 9.96039L25.2407 9.78625L25.3816 9.96039C27.8077 11.9476 30.3564 12.8055 32.0625 13.1691L32.2112 13.2024L32.2372 13.356C32.8712 17.9527 35.1538 20.5775 36.959 21.9681L37.0712 22.0551L37.0425 22.1857C36.8155 23.2869 36.7059 24.132 36.7059 24.8285C36.7059 27.1 37.3085 29.2229 38.4903 31.1358L38.5607 31.2434L38.4903 31.3612C38.6598 34.9565 30.6198 39.5558 27.8364 39.6608L27.7685 40.2856Z",
    fill: "#E20714"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_84_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 40,
    fill: "white",
    transform: "matrix(-1 0 0 1 41 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccionaLeafMarker);
export default __webpack_public_path__ + "static/media/acciona-leaf-marker.84a165ed.svg";
export { ForwardRef as ReactComponent };